import React from 'react'
import {NavLink} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
import {
    CContainer,
    CHeader,
    CHeaderBrand,
    CHeaderNav,
    CHeaderToggler,
    CNavLink,
    CNavItem, CHeaderDivider,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
    cilMenu,
    cilAccountLogout,
} from '@coreui/icons'

import {AppHeaderDropdown} from './index'
import AppBreadcrumb from "./AppBreadcrumb";
import {logo} from "../assets/brand/logo";

const AppHeader = () => {
    const dispatch = useDispatch()
    const sidebarShow = useSelector((state) => state.state.sidebarShow)

    return (
        <CHeader position="sticky" className={"mb-2 hidden-print"}>
            <CContainer fluid>
                <CHeaderToggler
                    className="ps-1"
                    onClick={() => {
                        dispatch({type: 'set', sidebarShow: !sidebarShow})
                    }}
                >
                    <CIcon icon={cilMenu} size="xl"/>
                </CHeaderToggler>
                <CHeaderBrand className="mx-auto d-md-none" to="/">

                </CHeaderBrand>
                <CHeaderNav className="d-none d-md-flex me-auto">

                </CHeaderNav>
                <CHeaderNav>
                    <CNavItem>
                        <CNavLink href="#/login">
                            <CIcon icon={cilAccountLogout} size="xl"/>
                        </CNavLink>
                    </CNavItem>
                </CHeaderNav>
                <CHeaderNav className="ms-3">
                    <AppHeaderDropdown/>
                </CHeaderNav>
            </CContainer>
            {/*<CHeaderDivider/>*/}
            {/*<CContainer fluid>*/}
            {/*    <AppBreadcrumb/>*/}
            {/*</CContainer>*/}
        </CHeader>
    )
}

export default AppHeader
